const axios = require('axios');
//const BASE_URL = "https://gx18.admintour.com/motor/API_Motor_Admintour";
const BASE_URL = "https://motor-reservas.cascadadelasanimas.cl/Motor/API_Motor_Admintour"
//const BASE_URL = "https://gestionalojamientosaebu.uy/Motor/API_Motor_Admintour";
//const BASE_URL = "https://gx18v2.admintour.com/motor/API_Motor_Admintour";
//const BOOK_URL = "https://gx18.admintour.com/motor/API_MotorReserva"
const BOOK_URL = "https://motor-reservas.cascadadelasanimas.cl/Motor/API_MotorReserva"
//const BOOK_URL = "https://gestionalojamientosaebu.uy/Motor/API_MotorReserva"
//const BOOK_URL = "https://gx18v2.admintour.com/motor/API_MotorReserva"
//const ADMINTOUR_BASEURL = "https://gx18.admintour.com/admintour/API_ChannelAdmintour";
const ADMINTOUR_BASEURL = "https://motor-reservas.cascadadelasanimas.cl/AdmintourGx18/API_ChannelAdmintour";
//const ADMINTOUR_BASEURL = "https://gestionalojamientosaebu.uy/AdmintourGX18/API_ChannelAdmintour";
//const ADMINTOUR_BASEURL = "https://gx18v2.admintour.com/admintour/API_ChannelAdmintour";
//const ADMINTOUR_ACTIVIDADES = "https://gx18.admintour.com/admintour/API_MotorActividades";
const ADMINTOUR_ACTIVIDADES = "https://motor-reservas.cascadadelasanimas.cl/AdmintourGx18/API_MotorActividades";
//const ADMINTOUR_ACTIVIDADES = "https://gestionalojamientosaebu.uy/AdmintourGX18/API_MotorActividades";

const LOSHEROES_BASEURL = "https://ext-api-recreactiva.losheroes.cl/prod/apilh/v2/lhcliente/";
const BACKMOTOR = "https://gx18.admintour.com/MotorCorreo";

// ✅ API de AEBU (hoteles 30 y 31), documentada en "API AEBU 2025":
// login con usuario/contraseña -> JWT válido 1h, y consulta de afiliado por
// cédula usando ese token.
const AEBU_BASEURL = "https://aebudigital.uy/ApiAfiliado";
// ⚠️ COMPLETAR con las credenciales reales que dio AEBU antes de usar esto en
// producción. Las dejo acá siguiendo el mismo criterio que ya usa este
// archivo con la "user-key" de LosHeroes (ver rutLosHeroes más abajo): la
// credencial queda embebida en el bundle del frontend. Si preferís no
// exponerla ahí (login/password son más sensibles que una sola API key),
// avisame y lo pasamos a variable de entorno o a un endpoint propio que haga
// el login del lado del servidor.
const AEBU_USERNAME = "TU_USUARIO_AEBU";
const AEBU_PASSWORD = "TU_PASSWORD_AEBU";

async function obtenerList() {
    try {
        const response = await axios.get(`${BASE_URL}/List`);
        return response.data;
    } catch (error) {
        console.error('Error fetching list data:', error);
        throw new Error('Error fetching list data');
    }
}

async function obtenerImagenCabezal(hotcod) {
    try {
        const response = await axios.get(`${BASE_URL}/Cabezal?hotcod=${hotcod}&nocache=${Date.now()}`);
        return response.data.archivofoto;
    } catch (error) {
        console.error('Error fetching header image:', error);
        throw new Error('Error fetching header image');
    }
}

async function obtenerMuestroCarritoSDT(hotcod,identificacarrito) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Carrito_SDT?hotcod=${hotcod}&identificacarrito=${identificacarrito}&nocache=${Date.now()}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}
//ACA TIENE QUE IR SI O SI LO NOCACHE
async function obtenerMuestroCarrito(codigo, sesion) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Carrito?hotcod=${codigo}&Sesion=${sesion}&nocache=${Date.now()}`
            , {
            headers: { 'Cache-Control': 'no-cache' }

        });
        return response.data.Carrito;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}

/*async function obtenerMuestroCarrito(codigo, sesion) {
    try {
      if (!codigo || !sesion) {
        console.warn('Faltan parámetros para obtener el carrito:', { codigo, sesion });
        return null;
      }

      const response = await axios.get(
        `${BASE_URL}/Muestro_Carrito?hotcod=${codigo}&Sesion=${sesion}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        }
      );

      return response.data.Carrito ?? null;
    } catch (error) {
      console.error('Error fetching cart data', error);
      return null;
    }
  }
  */

async function obtenerDetalleCarrito(codigo, sesion, lineahabitacion) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Detalle_Carrito?hotcod=${codigo}&Sesion=${sesion}&lineahabitacion=${lineahabitacion}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.Carrito;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}

async function grabarCarrito(carrito) {
    try {
        const response = await axios.post(`${BASE_URL}/Creo_Carrito_Hab`, carrito);
        return response.data;
    } catch (error) {
        console.error('Error creating cart:', error);
        throw new Error('Error creating cart');
    }
}

async function eliminarItemCarrito(BorrarHotel, BorrarSesion, BorrarLinea) {
    try {
        const response = await axios.post(`${BASE_URL}/Borro_Linea_Hab`, {
            BorrarHotel,
            BorrarSesion,
            BorrarLinea
        });
        return response.data.Carrito;
    } catch (error) {
        console.error('Error al eliminar el ítem del carrito:', error);
        throw new Error('Error al eliminar el ítem del carrito');
    }
}

async function confirmarReserva(hotelcarrito, Sesion, reservanombre, motorreservanombretitular,motorreservaapellidotitular, reservatelefono, reservacorreo, reservadireccion, motorreservatelefono, reservapais, reservatipodocumento, reservadocumento, reservafechanacimiento, reservaautocolor, reservaautomarca, reservaautomatricula, reservaobservaciones) {
    try {
        const response = await axios.post(`${BASE_URL}/Creo_Reserva`, {
            hotelcarrito,
            Sesion,
            reservanombre,
            motorreservanombretitular,
            motorreservaapellidotitular,
            reservatelefono,
            reservacorreo,
            reservadireccion,
            motorreservatelefono,
            reservapais,
            reservatipodocumento,
            reservadocumento,
            reservafechanacimiento,
            reservaautocolor,
            reservaautomarca,
            reservaautomatricula,
            reservaobservaciones
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}

async function obtenerDispoCalendario(hotcod, desdeFecha, hastaFecha) {
    try {
        const response = await axios.get(`${BASE_URL}/Dispo_Calendario?hotcod=${hotcod}&DesdeFecha=${desdeFecha}&hastafecha=${hastaFecha}&nocache=${Date.now()}`);
        return response.data.Calendario;
    } catch (error) {
        console.error('Error fetching availability data:', error);
        throw new Error('Error fetching availability data');
    }
}

async function obtenerMuestroTarifaTipoHab(hotel, tipoHab, fecha) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Tarifa_TipoHab?HotCod=${hotel}&TipoHab=${tipoHab}&FechaTarifa=${fecha}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.TarifaTipoHabItem;
    } catch (error) {
        console.error('Error fetching tariff data:', error);
        throw new Error('Error fetching tariff data');
    }
}

async function obtenerRegimenesTipoHab(hotel, tipoHab, fechadesde, fechahasta) {
    try {

        const response = await axios.get(`${BASE_URL}/Muestro_TarifaRango_TipoHab?HotCod=${hotel}&TipoHab=${tipoHab}&FechaDesde=${fechadesde}&FechaHasta=${fechahasta}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.TarifaTipoHabItem;
    } catch (error) {
        console.error('Error fetching tariff data:', error);
        throw new Error('Error fetching tariff data');
    }
}

async function obtenerMuestroTiposHabitacion(hotcod, desdeFecha, hastaFecha) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_TiposHabitacion?hotcod=${hotcod}&DesdeFecha=${desdeFecha}&hastafecha=${hastaFecha}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.TiposHabitacion;
    } catch (error) {
        console.error('Error fetching room types data:', error);
        throw new Error('Error fetching room types data');
    }
}

async function obtenerServiciosDeHabitacion(hotcod, tipoHab) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Servicios_TipoHab?hotcod=${hotcod}&TipoHab=${tipoHab}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.ServicioTipoHab;
    } catch (error) {
        console.error('Error fetching services data:', error);
        throw new Error('Error fetching services data');
    }
}

async function obtenerFotosTipoHab(hotcod, TipoHab) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_FotosTipoHab?hotcod=${hotcod}&TipoHab=${TipoHab}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.TiposHabFotos;
    } catch (error) {
        console.error('Error fetching photos data:', error);
        throw new Error('Error fetching photos data');
    }
}

async function obtenerDatosHotel(hotcod) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_DatosHotel?hotcod=${hotcod}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching photos data:', error);
        throw new Error('Error fetching photos data');
    }
}

async function graboReservaEnAdmintour(hotcod, reservamotor, sdt_motorreserva) {
    try {
        const response = await axios.post(`${ADMINTOUR_BASEURL}/GraboReservaMotor`, { hotcod, sdt_motorreserva, reservamotor });
        return response.data;
    } catch (error) {
        console.error('Error grabando reserva admintour:', error);
        throw new Error('Error grabando reserva admintour:');
    }
}
async function holaMundoAdmintour() {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/holamundo`);
        return response;
    } catch (error) {
        console.error('ERROR HOLA MUNDO:', error);
        throw new Error('ERROR HOLA MUNDO');
    }
}

async function obtenerPaises(hotcod) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/Pais?hotcod=${hotcod}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener paises', error);
        throw new Error('Error al obtener paises');
    }
}

async function obtenerDocumentos(hotcod) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/TipoDeDocumento?hotcod=${hotcod}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener documentos', error);
        throw new Error('Error al obtener documentos');
    }
}

async function obtenerReservasMotor(hotcod, motorReservaId) {
    try {
        const response = await axios.get(
            `${BOOK_URL}/Leer?MotorHotCod=${hotcod}&MotorReservaId=${motorReservaId}&nocache=${Date.now()}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching list data:", error);
        throw new Error("Error fetching list data");
    }
}

async function marcarReservaMotor(MotorHotCod, MotorReservaId) {
    try {
        const response = await axios.post(`${BOOK_URL}/Marca`, {MotorHotCod, MotorReservaId});
        return response.data;
    } catch (error) {
        console.error('Error saving payment:', error);
        throw new Error('Error saving payment');
    }
}

async function rutLosHeroes(rut) {
    try {
        const response = await axios.get(`${LOSHEROES_BASEURL}?rut=${rut}&nocache=${Date.now()}`, {
            headers: {
                "Content-Type": "application/json",
                "user-key": "8719df6cb2ebe951f35571b44ec83d6b"
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching rut data:", error);
        throw new Error("Error fetching rut data");
    }
}

// ================== AEBU (hoteles 30 y 31) ==================

// ✅ Cache simple del JWT de AEBU en memoria del módulo. El token dura 1
// hora; lo reutilizamos mientras le queden más de 2 minutos de vida, así no
// nos logueamos en cada búsqueda de tarifa (la API bloquea la cuenta 10
// minutos tras 3 intentos fallidos de login, así que además de innecesario
// sería arriesgado loguearse todo el tiempo).
let aebuTokenCache = { token: null, expiresAt: 0 };

async function loginAebu() {
    const now = Date.now();

    if (aebuTokenCache.token && aebuTokenCache.expiresAt - now > 2 * 60 * 1000) {
        return aebuTokenCache.token;
    }

    try {
        const response = await axios.post(
            `${AEBU_BASEURL}/Auth/login`,
            { username: AEBU_USERNAME, password: AEBU_PASSWORD },
            { headers: { 'Content-Type': 'application/json' } }
        );

        if (response.data?.Status !== 'OK' || !response.data?.Token) {
            throw new Error(response.data?.Message || 'No se pudo autenticar contra la API de AEBU');
        }

        aebuTokenCache = {
            token: response.data.Token,
            // Token real dura 1h; guardamos con margen (55min) para no
            // arriesgarnos a usarlo ya vencido por un desfasaje de reloj.
            expiresAt: now + 55 * 60 * 1000,
        };

        return aebuTokenCache.token;
    } catch (error) {
        console.error('Error al autenticar contra la API de AEBU:', error);
        throw new Error('Error al autenticar contra la API de AEBU');
    }
}

// ✅ Consulta si la cédula es afiliado/jubilado/socio deportivo de AEBU.
// La API no devuelve un booleano explícito: 200+data = encontrado,
// 404 = no encontrado (esto NO es un error de nuestro lado, es una respuesta
// válida que significa "no es afiliado"). Devolvemos siempre esta forma:
//   { esAfiliado: boolean, data: {...} | null }
async function consultarAfiliadoAebu(nroCedula) {
    try {
        const token = await loginAebu();

        const response = await axios.post(
            `${AEBU_BASEURL}/Afiliado`,
            { nroCedula },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return { esAfiliado: true, data: response.data?.data || null };
    } catch (error) {
        if (error?.response?.status === 404) {
            // No es afiliado: resultado válido, no lo tratamos como error.
            return { esAfiliado: false, data: null };
        }

        // ⚠️ A PROPÓSITO permisivo: cualquier otro fallo (CORS/red -como el
        // que da ahora mismo probando desde localhost contra
        // aebudigital.uy-, login caído, 400/500 de la API, etc.) NO debe
        // frenar la búsqueda de habitaciones. Lo dejamos bien visible en
        // consola y devolvemos "no afiliado" para que el flujo siga con
        // tarifa normal, en vez de dejar al cliente sin poder buscar
        // disponibilidad por un problema del lado de la API externa de AEBU.
        //
        // 🚧 TODO antes de ir a producción: esto significa que si el CORS no
        // se resuelve (agregando el header en el servidor de AEBU, o
        // proxyeando esta llamada desde nuestro propio backend en vez de
        // hacerla directo desde el navegador), NUNCA se va a poder ofrecer la
        // tarifa de afiliado real -siempre va a caer en tarifa normal en
        // silencio, sin que nadie lo note-. Hoy esto destraba las pruebas del
        // resto del flujo, pero el problema de fondo sigue sin resolverse.
        console.error(
            '[AEBU] No se pudo consultar el afiliado (se continúa con tarifa normal):',
            error
        );
        return { esAfiliado: false, data: null };
    }
}

async function obtenerTarifaPorTipoCliente(hotCod, TipoHab, FechaTarifa,TipoCliente ) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Tarifa_TipoCliente?hotcod=${hotCod}&TipoHab=${TipoHab}&FechaTarifa=${FechaTarifa}&TipoCliente=${TipoCliente}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}

async function obtenerRegimenPorTipoCliente(hotCod, TipoHab, FechaDesde, FechaHasta,TipoCliente ) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_TarifaRango_TipoCliente?hotcod=${hotCod}&TipoHab=${TipoHab}&FechaDesde=${FechaDesde}&FechaHasta=${FechaHasta}&TipoCliente=${TipoCliente}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}


async function rutTieneReserva(hotcod,rut,ReservaDesde,ReservaHasta) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/ExisteReservaRut?hotcod=${hotcod}&rut=${rut}&ReservaDesde=${ReservaDesde}&ReservaHasta=${ReservaHasta}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener rut tiene reserva', error);
        throw new Error('Error al rut tiene reservas');
    }
}

async function grabarPagoTransbank(pagohotel, Sesion, pagomoneda, pagoimporte, pagoorden, pagotarjeta) {
    try {
        const response = await axios.post(`${BASE_URL}/Grabo_Pago_Reserva`, {pagohotel, Sesion, pagomoneda, pagoimporte, pagoorden, pagotarjeta});
        return response.data;
    } catch (error) {
        console.error('Error saving payment:', error);
        throw new Error('Error saving payment');
    }
}

async function leerParametroURL(CodigoParametro) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/Leo_URLParametro?CodigoParametro=${CodigoParametro}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener rut tiene reserva', error);
        throw new Error('Error al rut tiene reservas');
    }
}

async function enctriptoParaAdmintour(DatoaEncriptar) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/Encripto_Admintour?DatoaEncriptar=${DatoaEncriptar}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener rut tiene reserva', error);
        throw new Error('Error al rut tiene reservas');
    }
}

async function datosPax(hotcod, DocumentoCliente) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/Devuelvo_DatosCliente?hotcod=${hotcod}&DocumentoCliente=${DocumentoCliente}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener datos cliente', error);
        throw new Error('Error obtener datos cliente');
    }
}

async function obtenerCarritoCompleto(hotCod, sesion) {
    const carrito = await obtenerMuestroCarrito(hotCod, sesion);
    let total = 0;
    if (carrito && carrito.length > 0) {
        total = carrito.reduce(
            (acc, item) => acc + parseFloat(item.CarritoItemTotal || 0),
            0
        );
    }
    return {
        cartNoPrice: carrito || [],
        price: total
    };
};

async function envioCorreo(nombre, email) {
    try {
        const response = await axios.post(`${BACKMOTOR}/send-email`, {nombre, email});
        return response.data;
    } catch (error) {
        console.error('Error saving payment:', error);
        throw new Error('Error saving payment');
    }
}


async function dobleChequeoDisponibilidad(hotcod, DesdeFecha, hastafecha, BuscoTipoHab) {
    try {
        const response = await axios.get(`${BASE_URL}/Disponibilidad_TipoHabitacion?hotcod=${hotcod}&DesdeFecha=${DesdeFecha}&hastafecha=${hastafecha}&BuscoTipoHab=${BuscoTipoHab}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response;
    } catch (error) {
        console.error('Error al obtener disponibilidad', error);
        throw new Error('Error al obtener disponibilidad');
    }
}


async function tarifaNoLineal(hotcod, hotprodcod, fechaprecio) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/LeoTarifa_PaxNoLineal?hotcod=${hotcod}&hotprodcod=${hotprodcod}&fechaprecio=${fechaprecio}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener tarifa no lineal', error);
        throw new Error('Error al obtener tarifa no lineal');
    }
}

async function disponibilidadEnCalendario(hotcod, DesdeFecha, hastafecha) {
    try {
        const response = await axios.get(`${BASE_URL}/Dispo_Calendario?hotcod=${hotcod}&DesdeFecha=${DesdeFecha}&hastafecha=${hastafecha}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener dispo calendario', error);
        throw new Error('Error al obtener dispo calendario');
    }
}

async function obtenerActividades(hotcod) {
    try {
        const response = await axios.get(`${ADMINTOUR_ACTIVIDADES}/Devuelvo_Actividades?hotcod=${hotcod}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener las actividades', error);
        throw new Error('Error al obtener las actividades');
    }
}

async function obtenerDetalleActividad(hotcod,hotprodcod,fecha) {
    try {
        const response = await axios.get(`${ADMINTOUR_ACTIVIDADES}/Actividad_Detalle?hotcod=${hotcod}&hotprodcod=${hotprodcod}&fecha=${fecha}&nocache=${Date.now()}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener las actividades', error);
        throw new Error('Error al obtener las actividades');
    }
}

//https://gx18.admintour.com/motor/API_Motor_Admintour/Dispo_Calendario?hotcod=26&DesdeFecha=2026-03-22&hastafecha=2026-03-26
module.exports = {
    obtenerList,
    obtenerImagenCabezal,
    obtenerDispoCalendario,
    obtenerMuestroTarifaTipoHab,
    obtenerMuestroTiposHabitacion,
    obtenerServiciosDeHabitacion,
    grabarCarrito,
    obtenerMuestroCarrito,
    obtenerMuestroCarritoSDT,
    eliminarItemCarrito,
    confirmarReserva,
    obtenerDetalleCarrito,
    obtenerFotosTipoHab,
    obtenerDatosHotel,
    graboReservaEnAdmintour,
    holaMundoAdmintour,
    obtenerReservasMotor,
    obtenerPaises,
    obtenerDocumentos,
    rutLosHeroes,
    consultarAfiliadoAebu,
    obtenerTarifaPorTipoCliente,
    rutTieneReserva,
    grabarPagoTransbank,
    leerParametroURL,
    enctriptoParaAdmintour,
    datosPax,
    obtenerCarritoCompleto,
    obtenerRegimenesTipoHab,
    obtenerRegimenPorTipoCliente,
    envioCorreo,
    dobleChequeoDisponibilidad,
    tarifaNoLineal,
    marcarReservaMotor,
    disponibilidadEnCalendario,
    obtenerActividades,
    obtenerDetalleActividad
};